/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
 */
export interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    Game: string;
    /**
     * https://developers.facebook.com/docs/games/monetize/in-app-purchases#verification
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    FbInstantPurchaseSignedData: string;
    /**
     * Публичный id нашего ордера, к которому клиент относит покупку. Untrusted: сервер использует его, только
     * если ордер принадлежит аккаунту из JWT и совпадает по товару с подписанным FB чеком.
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    PublicOrderId?: string | null;
    /**
     * Legacy-контракт бандлов FB, собранных с #fxid-1595 (08.07.2026) до #fxid-1767: номер ордера JSON-строкой
     * {"public_order_id":"..."}. Принимается постоянно — бандлы FB могут жить годами.
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    DeveloperPayloadHint?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest(value: object): value is FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('FbInstantPurchaseSignedData' in value) || value['FbInstantPurchaseSignedData'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'FbInstantPurchaseSignedData': json['FbInstantPurchaseSignedData'],
        'PublicOrderId': json['PublicOrderId'] == null ? undefined : json['PublicOrderId'],
        'DeveloperPayloadHint': json['DeveloperPayloadHint'] == null ? undefined : json['DeveloperPayloadHint'],
    };
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(value?: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'FbInstantPurchaseSignedData': value['FbInstantPurchaseSignedData'],
        'PublicOrderId': value['PublicOrderId'],
        'DeveloperPayloadHint': value['DeveloperPayloadHint'],
    };
}

